import { render, staticRenderFns } from "./ConfirmButtons.vue?vue&type=template&id=4566dc04&"
import script from "./ConfirmButtons.vue?vue&type=script&lang=js&"
export * from "./ConfirmButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CStack: require('@chakra-ui/vue').CStack, CBox: require('@chakra-ui/vue').CBox})
